import logo from './logo.svg';
import favicon from './favicon.svg';
import placeholder from './placeholder.png';


export const img = {
    logo,
    favicon,
    placeholder

}

export const categoryMap = {
    'Balkezes': 'Balkezes',
    'Jobbkezes': 'Jobbkezes',
    'Héthúros': 'Héthúros',
    'Gitáresősítő fej': 'Fej',
    'Gitár kábel': 'Gitár kábel',
    'Effekt pedál': 'Pedál',
    'Multieffekt pedál': 'Mulltieffekt',
    'Pengető': 'Pengető',
    'Gitár láda': 'Láda',
    'Puha tok': 'Puha tok',
    'Gitár kombó': 'Combó',
    'Heveder': 'Heveder',
    'Gitárhúr': 'Húr',
    'Kemény tok': 'Kemény tok',
};

export const subCategories = {
    Gitár: ['Balkezes', 'Jobbkezes', 'Héthúros'],
    Erősítő: ['Gitáresősítő fej', 'Gitár kombó', 'Gitár láda'],
    Effekt: ['Effekt pedál', 'Multieffekt pedál'],
    Kiegészítő: ['Gitár kábel', 'Pengető', 'Puha tok', 'Heveder', 'Gitárhúr', 'Kemény tok']
  };

export const colors = ["Piros", "Fekete", "Fehér", "Zöld", "Lila", "Szürke", "Sunburst", "Kék", "Natúr Fa",
    "Narancssárga", "Barna", "Sárga", "Rózsaszín", "Bordó", "Szivárvány", "Mintás"];

export const brands = [
    "Cort", "Fender", "Gibson", "Ibanez", "Epiphone", "Squier", "Jackson",
    "Marshall", "ENGL", "Orange", "Laney", "MesaBoogei", "Line6", "Boss",
    "Dunlop", "Ernie Ball", "Elixir", "D'Addario"
];



export const models = [
    "Stratocaster", "Superstrat", "Les Paul", "Telecaster", "Jaguár", "SG",
    "Flying V", "Explorer", "Mustang", "Iceman", "Csöves", "Tranzisztoros",
    "Döntött", "Egyenes", "Distortion", "Overdrive", "Fuzz", "Delay",
    "Chorus", "Flanger", "Phaser", "Wah", "EQ", "Reverb", "Multieffekt",
    "Textil", "Bőr", "Farmer", "Acél", "Műanyag", "Fa", "Patch", "Gitár kábel"
];


